// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2354":"c508dc98","5377":"c508dc98"}[chunkId] + ".chunk.css";
};